module.exports = __webpack_public_path__ + "slick.526d7fdf63614222d376.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/slick/fonts/slick.svg
// module id = 1289
// module chunks = 2